module.exports = __webpack_public_path__ + "static/feature-staffing-f4cef14e186700846445a68871ad15f9.png";